import React from 'react'
import AutosuggestHighlightMatch from 'autosuggest-highlight/umd/match'
import AutosuggestHighlightParse from 'autosuggest-highlight/umd/parse'

export default function (suggestion, { query, getSuggestionValue }) {
  const label = getSuggestionValue(suggestion)

  return (
    <span>{label.length ? highlightOrDimText(label, query) : '\u00a0'}</span>
  )
}

function highlightOrDimText (label, query) {
  const matches = AutosuggestHighlightMatch(label, query)
  const parts = AutosuggestHighlightParse(label, matches)

  return parts.map((part, index) => {
    const className = part.highlight
      ? 'zb-dropdown-list-item-text-highlight'
      : 'zb-dropdown-list-item-text-dimmed'

    return (
      <span className={className} key={index}>
        {part.text}
      </span>
    )
  })
}
